import React from "react";
import useDimensions from "../hooks/useDimensions";

const PositionPreview = ({
  positions,
  currentPage,
  containerRef,
  handleRemoveSign,
}) => {
  const pdf = useDimensions(containerRef);

  return (
    <>
      {positions.map(
        (pos, index) =>
          pos.page === currentPage && (
            <div
              key={index}
              className="ps-sign-position"
              style={{
                left: `${pos.normalizedX * pdf.width}px`,
                top: `${pos.normalizedY * pdf.height}px`,
              }}
            >
              <span className="ps-sign-label">Signature {index + 1}</span>
              <button
                className="ps-sign-remove-btn"
                onClick={() => handleRemoveSign(index)}
              >
                x
              </button>
            </div>
          )
      )}
    </>
  );
};

export default PositionPreview;
